import {Injectable} from '@angular/core';
import {AbstractPopupService} from "../../../abstract-popup.service";
import {SupportPopupComponent} from "./support-popup.component";
import {TranslateService} from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class SupportPopupService extends AbstractPopupService<SupportPopupComponent> {

    constructor(private readonly translateService: TranslateService) {
        super(SupportPopupComponent);
    }

    showSupportPopup() {
        this.showPopup(new SupportPopupComponent(this.translateService));
    }

    protected fillPopupInstance(popupInstance: SupportPopupComponent, preparedPopup: SupportPopupComponent) {

    }
}
